angular.module('app').config((authTokenProvider: any) => {
  authTokenProvider.configure({
    authTokenApi: '/ssccampus/token?scheduling_api=None',
    tokenExpiryTime: 5
  });
});
